var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHourglass = function SvgHourglass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7 22v-5.2c0-1.273.527-2.494 1.464-3.394A5.1 5.1 0 0 1 12 12c1.326 0 2.598.506 3.536 1.406A4.7 4.7 0 0 1 17 16.8V22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7 2v5.2c0 1.273.527 2.494 1.464 3.394.938.9 2.21 1.406 3.536 1.406a5.1 5.1 0 0 0 3.536-1.406A4.7 4.7 0 0 0 17 7.2V2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M5 22h14M5 2h14M12 20v1M8 8h8"
  })));
};
export default SvgHourglass;